/* eslint-disable import/no-named-default */
import styled from "styled-components";
import PropTypes from "prop-types";
import { default as ReactModal } from "react-modal";

const Modal = ({
	children,
	isOpen,
	onAfterOpen = undefined,
	onRequestClose,
	shouldCloseOnOverlayClick,
	heading = undefined,
	width = "auto",
}) => {
	const modalStyles = {
		overlay: {
			backgroundColor: "rgba(0, 0, 0, 0.75)",
			zIndex: 999,
		},
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			width,
			maxWidth: "900px",
			overflow: "hidden",
			padding: 0,
			border: "none",
		},
	};

	return (
		<ReactModal
			isOpen={isOpen}
			onAfterOpen={onAfterOpen}
			onRequestClose={onRequestClose}
			style={modalStyles}
			shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
			ariaHideApp={false}
		>
			{heading && (
				<>
					<Header>{heading}</Header>
					<Hr />
				</>
			)}
			{children}
		</ReactModal>
	);
};

const Header = styled.h3`
	font-size: 20px;
	font-weight: 500;
	letter-spacing: 0.3px;
	color: #6c6a6a;
`;
const Hr = styled.hr`
	margin: 20px -20px;
`;

Modal.defaultProps = {
	onAfterOpen: () => {},
	shouldCloseOnOverlayClick: true,
	width: "auto",
};

Modal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	children: PropTypes.node.isRequired,
	onAfterOpen: PropTypes.func,
	onRequestClose: PropTypes.func.isRequired,
	shouldCloseOnOverlayClick: PropTypes.bool,
	width: PropTypes.string,
};

export default Modal;
